export default "__VITE_ASSET__BkTW_qkx__"